import { render, staticRenderFns } from "./TechnologyComponent.vue?vue&type=template&id=7a2d9938"
import script from "./TechnologyComponent.vue?vue&type=script&lang=js"
export * from "./TechnologyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports